import React from 'react';
//import PropTypes from 'prop-types';

import decorate from '../common/utils/decorate';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Card from '../ui/Card';
import Text from '../ui/Text';
import Grid from '../ui/Grid';
import Divider from '../ui/Divider';

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {};

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    renderQueryPlate = () => {
      const { cart, cartChildren } = this.props;

      if (cartChildren) {
        return <Card>{cartChildren}</Card>;
      }

      const {
        langString,
        priceFormat,
        daysFormat,

        service,
        method,
        methodQuery,
        company,
        tariff,
        pickupPoint
      } = this.context;

      const tariffQuery =
        method && method.type !== 1
          ? methodQuery?.[method.id]?.tariffs.find(
              (item) =>
                item.service.id === service?.id &&
                item.company === company?.id &&
                item.id == tariff?.id
            )
          : null;

      const deliveryDays =
        (method?.type === 1 ? pickupPoint : tariffQuery)?.days ?? null;
      const deliveryPrice =
        cart.delivery ??
        (method?.type === 1 ? pickupPoint : tariffQuery)?.price ??
        null;

      return (
        <Card>
          <Grid container align="end">
            <Grid>
              <Text strong color="hint" size="lg">
                {langString('goods.count')}:
              </Text>
            </Grid>
            <Grid align="end">
              <Text strong color="hint" size="xl" align="right">
                {cart.count}
              </Text>
            </Grid>
          </Grid>

          <Grid container align="end">
            <Grid>
              <Text strong color="hint" size="lg">
                {langString('amount.for')}:
              </Text>
            </Grid>
            <Grid align="end">
              <Text strong color="hint" size="xl" align="right">
                {priceFormat(cart.price)}
              </Text>
            </Grid>
          </Grid>

          {deliveryDays !== null ? (
            <Grid container align="end">
              <Grid>
                <Text strong color="hint" size="lg">
                  {langString('delivery.time')}:
                </Text>
              </Grid>
              <Grid align="end">
                <Text strong color="hint" size="xl" align="right">
                  {daysFormat(deliveryDays)}
                </Text>
              </Grid>
            </Grid>
          ) : null}

          {deliveryPrice !== null ? (
            <Grid container align="end">
              <Grid>
                <Text strong color="hint" size="lg">
                  {langString('delivery.price')}:
                </Text>
              </Grid>
              <Grid align="end">
                <Text strong color="hint" size="xl" align="right">
                  {priceFormat(deliveryPrice)}
                </Text>
              </Grid>
            </Grid>
          ) : null}

          <Grid container align="end">
            <Grid>
              <Text strong color="hint" size="lg">
                {langString('discount')}:
              </Text>
            </Grid>
            <Grid align="end">
              <Text strong color="hint" size="xl" align="right">
                {priceFormat(cart.discount)}
              </Text>
            </Grid>
          </Grid>

          <Grid container>
            <Grid>
              <Divider />
            </Grid>
          </Grid>

          <Grid container align="end">
            <Grid>
              <Text strong color="hint" size="xl">
                {langString('amount')}:
              </Text>
            </Grid>
            <Grid align="end">
              <Text strong size="xl2" align="right">
                {priceFormat(cart.price - cart.discount + (deliveryPrice || 0))}
              </Text>
            </Grid>
          </Grid>
        </Card>
      );
    };

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { children, cart, rightChildren } = this.props;

      const { isSmall } = this.context;

      if (isSmall) {
        return (
          <Grid container>
            <Grid grow={3}>
              {cart ? this.renderQueryPlate() : null}

              <Card>{children}</Card>

              {rightChildren}
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid container align="start">
            <Grid grow={3}>
              <Card>{children}</Card>
            </Grid>

            {cart || rightChildren ? (
              <Grid grow={2}>
                {cart ? this.renderQueryPlate() : null}

                {rightChildren}
              </Grid>
            ) : null}
          </Grid>
        );
      }
    }
  }
);
